import { render } from "./RegisterWindow.vue?vue&type=template&id=082eebb2&scoped=true"
import script from "./RegisterWindow.vue?vue&type=script&lang=js"
export * from "./RegisterWindow.vue?vue&type=script&lang=js"

import "./RegisterWindow.vue?vue&type=style&index=0&id=082eebb2&lang=scss&scoped=true"

import exportComponent from "Z:\\Adamovyveci\\uhkprojects\\owezaverecny\\secutalk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082eebb2"]])

export default __exports__